/*
 * @Author: yusha
 * @Date: 2023-06-12 11:50:10
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-11-10 14:28:26
 * @Description:
 */

import { computed, ref } from 'vue'
import { useRoute, useRouter, onBeforeRouteUpdate, LocationQuery } from 'vue-router'
import { setTabData, getTabData } from '@/util/common'
export default ({ TabName, EmptyTabName, defaultValue }: { TabName:string, EmptyTabName?: string, defaultValue?: any }, callback: () => void) => {
  let sourceTabs = ''
  const BaseTabs = ref()
  const router = useRouter()
  const { query } = useRoute()

  const setTab = (val: any) => setTabData(val, EmptyTabName)
  const getTab = (val: any) => getTabData(val, EmptyTabName)
  const setStatus = (query: LocationQuery, fn?: any) => { 
    BaseTabs.value = setTab(query?.[TabName] ?? defaultValue)
    sourceTabs = setTab(query?.[TabName])
    fn && fn()
  }

  setStatus(query)
  onBeforeRouteUpdate((to) => {
    const { query } = to
    setStatus(query, callback)
  })

  const tabData = computed({
    get: () => {
      return BaseTabs.value
    },
    set: (val) => {
      BaseTabs.value = setTab(val)
      refresh()
    }
  })

  const showTabData = computed(() => getTab(BaseTabs.value))

  const refresh = () => {
    if (sourceTabs === BaseTabs.value) {
      callback()
    } else {
      router.push({
        query: {
          [TabName]: showTabData.value
        }
      })
    }
  }

  return {
    tabData,
    [TabName]: showTabData,
    setStatus
  }
}
